module.exports = __webpack_public_path__ + "img/terminal-circle.77b02a57.svg";